(() => {
  if (customElements.get('eala-promo-popup')) return;
  class EalaPromoPopup extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.storageKey = `eala:promo:${this.dataset.campaign || 'welcome'}`;
      this.frequency = Math.max(1, Number(this.dataset.frequency) || 7) * 86400000;
      this.editor = this.dataset.editor === 'true';
      this.onTrigger = (event) => {
        if (event.target.closest('[data-eala-promo-open]')) this.open();
      };
      this.onSectionSelect = (event) => {
        if (event.detail.sectionId === this.dataset.sectionId) this.open();
      };
      this.onVisibility = () => {
        if (!document.hidden && !this.timer && !this.shown && !this.suppressed()) this.schedule(2000);
      };
      this.querySelectorAll('[data-promo-dismiss]').forEach((button) => button.addEventListener('click', () => this.dialog.close()));
      this.querySelector('[data-promo-cta]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => this.cleanup());
      document.addEventListener('click', this.onTrigger);
      if (this.editor) document.addEventListener('shopify:section:select', this.onSectionSelect);
      this.triggers = [...document.querySelectorAll('[data-eala-promo-open]')];
      this.triggers.forEach((trigger) => { trigger.hidden = false; });
      if (!this.editor && this.dataset.autoOpen === 'true') {
        document.addEventListener('visibilitychange', this.onVisibility);
        if (!this.suppressed()) this.schedule((Number(this.dataset.delay) || 12) * 1000);
      }
    }
    suppressed() {
      try { return Number(localStorage.getItem(this.storageKey) || 0) > Date.now(); }
      catch (_) { return this.shown === true; }
    }
    remember() {
      try { localStorage.setItem(this.storageKey, String(Date.now() + this.frequency)); }
      catch (_) { /* Dismissal still applies for this page when storage is unavailable. */ }
    }
    schedule(delay) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.timer = null;
        if (!this.isConnected || this.shown || this.suppressed()) return;
        if (document.hidden) return;
        if (document.body.classList.contains('eala-menu-open') || document.querySelector('dialog[open], .eala-chatbot-panel:not([hidden])') || document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) {
          this.schedule(2000);
          return;
        }
        this.open();
      }, delay);
    }
    open() {
      if (!this.dialog || this.dialog.open || document.body.classList.contains('eala-menu-open') || document.querySelector('dialog[open]')) return;
      clearTimeout(this.timer);
      this.timer = null;
      this.previousOverflow = document.body.style.overflow;
      this.previousFocus = document.activeElement;
      this.dialog.showModal();
      document.body.style.overflow = 'hidden';
      document.body.classList.add('eala-promo-open');
      this.shown = true;
      if (!this.editor) this.remember();
    }
    cleanup() {
      document.body.classList.remove('eala-promo-open');
      document.body.style.overflow = this.previousOverflow || '';
      if (this.previousFocus?.isConnected && this.previousFocus !== document.body) this.previousFocus.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('click', this.onTrigger);
      document.removeEventListener('visibilitychange', this.onVisibility);
      document.removeEventListener('shopify:section:select', this.onSectionSelect);
      this.triggers?.forEach((trigger) => { trigger.hidden = true; });
      if (this.dialog?.open) { this.dialog.close(); this.cleanup(); }
    }
  }
  customElements.define('eala-promo-popup', EalaPromoPopup);
})();
